import { Injectable } from '@angular/core';
import { BaseHttpService, PageResponse } from '../../auth/base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryItem } from './delivery-item';


export class Delivery {
  id: number;
  route_id: number;
  name: string;
  phone: string;
  address: Address;
  status: string;
  items: DeliveryItem[] = [];
  instructions: string;
  eta: number;
}

export class DeliverySearchParams {
  page: number;
  size: number;

}

export class Address {
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryService extends BaseHttpService {

  private baseURL: string = 'social/post';
  private endPointURL: string;
  constructor(protected client: HttpClient, protected snackbar: MatSnackBar) {
    super(client, snackbar);
  }

  async create(data: Delivery) {
    this.endPointURL = this.baseURL;
    return await this.post<Delivery>(this.endPointURL, data);
  }

  async update(data: Delivery) {
    this.endPointURL = this.baseURL;
    return await this.put<Delivery>(this.endPointURL, data);
  }

  async deleteById(id: string) {
    this.endPointURL = this.baseURL + id;
    return await this.delete<boolean>(this.endPointURL);
  }

  async findAll(searchParams: DeliverySearchParams) {
    this.endPointURL = this.baseURL;
    return await this.get<PageResponse<Delivery>>(this.endPointURL, searchParams);
  }

  async findById(id: string) {
    this.endPointURL = this.baseURL + '/' + id;
    return await this.get<Delivery>(this.endPointURL);
  }

  async findByRef(ref: string) {
    this.endPointURL = this.baseURL + '/ref/' + ref;
    return await this.get<Delivery>(this.endPointURL);
  }


}
